export const environment = {
  "name": "blue",
  "prefix": "blue.",
  "type": "development",
  "apiUrl": "https://blue.api.accredible.com",
  "experimentsApiUrl": "https://experiments-a.api.accredible.com",
  "socketUrl": "https://blue.socket.accredible.com",
  "credentialNetUrl": "https://blue.credential.net",
  "courseFinderUrl": "https://blue.coursefinder.io",
  "dashboardUrl": "https://blue.dashboard.accredible.com",
  "accountsUrl": "https://blue.accounts.accredible.com",
  "spotlightUrl": "https://blue.employment.accredible.com",
  "salesCalculatorUrl": "https://blue.calculator.accredible.com",
  "accredishareUrl": "https://blue.accredishare.api.accredible.com",
  "directoryOfDirectoriesUrl": "https://blue.directories.accredible.com",
  "stripeKey": "pk_test_cAeVkx5DhTMwelsEudggtgxC",
  "getSocialId": "b9584c5e",
  "bugsnagApiKey": "",
  "bugsnagRendererApiKey": "",
  "theme": "",
  "version": "25.25.0",
  "recaptchaV2SiteKey": "6LcOWiETAAAAADQyIj7-BSOG8KNsnYIsV84jJDfM",
  "recaptchaV3SiteKey": "6LeLojsaAAAAAB8OV2zHmQvFW66cq79i-xJqdu8j",
  "googleFontApiKey": "AIzaSyCgKPyvoy_y1MMvTtTqIex7OIBlVjbYkYE",
  "themeMicroserviceBaseUrl": "https://theme.ms.credential.net",
  "theming": false,
  "themingS3BaseUrl": "",
  "integrationsApiUrl": "https://blueintegrations.api.accredible.com",
  "zoomAppClientId": "",
  "dashboardGainsightTagKey": "AP-EGY1FB9PXTHZ-2-4",
  "recipientGainsightTagKey": "AP-DDKMXRZFO5TE-2-4",
  "spotlightGainsightTagKey": "AP-XETC94EVLZS5-2-4",
  "unlayerProjectId": "236376",
  "slackClientId": "2228435857.8884109478882"
};